/*
 * SIJL vaste bestelbalk (mobiel)
 *
 * Op productpagina's met het koffie-koopblok (sections/sijl-buy-box.liquid) staat de knop
 * 'In winkelwagen' op een telefoon pas na wat scrollen in beeld. Deze balk staat onderin
 * zolang die knop niet in beeld is, met de naam, de prijs en de gekozen variant.
 *
 * De knop in de balk klikt op de gewone knop (#sijl-main-atc). Zo blijven variant, aantal en
 * de bestaande winkelwagenlogica van sijl-buy-box.js leidend en hoeft hier niets dubbel.
 * Is de gekozen variant uitverkocht, dan blijft de balk weg.
 * Opmaak: assets/sijl-sticky-atc.css. Geladen vanuit layout/theme.liquid op productpagina's.
 */
(function () {
  var hoofdknop = document.getElementById('sijl-main-atc');
  if (!hoofdknop || !('IntersectionObserver' in window)) return;

  var sectie = hoofdknop.closest('.shopify-section') || document.body;
  var titelEl = sectie.querySelector('.sijl-title') || sectie.querySelector('h1');
  var mobiel = window.matchMedia('(max-width: 749px)');
  var hoofdknopInBeeld = true;

  var balk = document.createElement('div');
  balk.className = 'sijl-sticky-atc';
  balk.setAttribute('aria-hidden', 'true');
  balk.innerHTML =
    '<div class="sijl-sticky-atc__info">' +
    '<span class="sijl-sticky-atc__titel"></span>' +
    '<span class="sijl-sticky-atc__meta"></span>' +
    '</div>' +
    '<button type="button" class="sijl-atc-button sijl-sticky-atc__knop" tabindex="-1">In winkelwagen</button>';

  var titel = balk.querySelector('.sijl-sticky-atc__titel');
  var meta = balk.querySelector('.sijl-sticky-atc__meta');
  var knop = balk.querySelector('.sijl-sticky-atc__knop');
  titel.textContent = titelEl ? titelEl.textContent.trim() : '';
  sectie.appendChild(balk);

  function tekst(id) {
    var el = document.getElementById(id);
    return el ? el.textContent.trim() : '';
  }

  // Bezig met toevoegen of een foutmelding: de gewone knop is dan tijdelijk uitgeschakeld.
  function bezig() {
    return hoofdknop.classList.contains('is-loading') || hoofdknop.classList.contains('has-error');
  }

  function tonen() {
    var uitverkocht = hoofdknop.disabled && !bezig();
    var aan = mobiel.matches && !hoofdknopInBeeld && !uitverkocht;
    balk.classList.toggle('is-zichtbaar', aan);
    balk.setAttribute('aria-hidden', aan ? 'false' : 'true');
    knop.tabIndex = aan ? 0 : -1;
    document.documentElement.classList.toggle('sijl-sticky-atc-actief', aan);
  }

  function bijwerken() {
    // Gewone stand: de knop bevat prijs en variant. Anders ('Naar winkelwagen...', een
    // foutmelding of 'Uitverkocht') neemt de balk de tekst van de gewone knop over.
    var normaal = !!document.getElementById('sijl-main-atc-price');
    if (normaal) {
      meta.textContent = [tekst('sijl-main-atc-price'), tekst('sijl-main-atc-variant')].filter(Boolean).join(' · ');
    } else if (!bezig()) {
      meta.textContent = '';
    }
    knop.disabled = hoofdknop.disabled;
    knop.textContent = normaal ? 'In winkelwagen' : hoofdknop.textContent.trim();
    knop.classList.toggle('is-loading', hoofdknop.classList.contains('is-loading'));
    tonen();
  }

  new IntersectionObserver(function (items) {
    hoofdknopInBeeld = items[0].isIntersecting;
    tonen();
  }).observe(hoofdknop);

  new MutationObserver(bijwerken).observe(hoofdknop, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['disabled', 'class']
  });

  if (mobiel.addEventListener) {
    mobiel.addEventListener('change', tonen);
  } else if (mobiel.addListener) {
    mobiel.addListener(tonen);
  }

  knop.addEventListener('click', function () {
    if (!hoofdknop.disabled) hoofdknop.click();
  });

  bijwerken();
})();
